import { ListsActions } from './lists.actions';

export const lists = {
  namespaced: true,
  state: () => ({
    lists: [],
  }),
  mutations: {
    setLists(state, listsData) {
      state.lists = listsData;
    },
  },
  actions: {
    ...ListsActions,
  },
  getters: {
    lists(state) {
      return state.lists;
    },
  },
};

export default lists;
